import React from 'react';
import {
  Box,
  Container,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useColorModeValue,
} from '@chakra-ui/react';
import CustomFieldsManager from './components/CustomFieldsManager';

const SettingsPage: React.FC = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Container maxW="container.lg" py={8}>
      <Heading mb={6}>Settings</Heading>
      <Box
        bg={bgColor}
        borderRadius="lg"
        border="1px"
        borderColor={borderColor}
        overflow="hidden"
      >
        <Tabs>
          <TabList px={4}>
            <Tab>Custom Fields</Tab>
            {/* Add more tabs here as needed */}
          </TabList>

          <TabPanels>
            <TabPanel>
              <CustomFieldsManager />
            </TabPanel>
            {/* Add more tab panels here as needed */}
          </TabPanels>
        </Tabs>
      </Box>
    </Container>
  );
};

export default SettingsPage; 